import React from 'react';
import { GlobalQuickCreateProvider } from '@/components/providers/GlobalQuickCreateProvider';
import { CSPostHogProvider, PostHogPageView } from '@/components/providers/posthog-provider';
import { PrimaryThemeProvider } from '@/components/providers/primary-theme-provider';
import { ExcelOperationOverlay } from '@/lib/excel/operation-overlay';
import { isKnownViteRoutePath } from '@/routes/route-map';
import { AuthProvider } from '@/contexts/auth-context';
import { useAppPathname } from '@/routing';

interface ViteClientProvidersProps {
  children: React.ReactNode;
}

const isAuthRoute = (pathname: string) => pathname === '/xac-thuc' || pathname.startsWith('/xac-thuc/');

export function ViteClientProviders({ children }: ViteClientProvidersProps) {
  const pathname = useAppPathname();
  const shouldUseAuthProvider = !isAuthRoute(pathname) && isKnownViteRoutePath(pathname);
  const content = shouldUseAuthProvider ? (
    <AuthProvider>
      <GlobalQuickCreateProvider>{children}</GlobalQuickCreateProvider>
    </AuthProvider>
  ) : (
    children
  );

  return (
    <CSPostHogProvider>
      <PrimaryThemeProvider>
        <PostHogPageView />
        {content}
        <ExcelOperationOverlay />
      </PrimaryThemeProvider>
    </CSPostHogProvider>
  );
}
